.DiceboundModal {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: rgba(34, 34, 34, 0.5);
}
.DiceboundModal .Header,
.DiceboundModal .Footer {
  font-size: 0.5em;
  text-align: center;
  font-family: var(--header-font);
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
  margin-top: 2em;
  margin-bottom: 2em;
}
.DiceboundModal .Header .BigText,
.DiceboundModal .Footer .BigText {
  font-size: 1.3em;
  line-height: 1em;
}
.DiceboundModal .Header .SmallText,
.DiceboundModal .Footer .SmallText {
  font-size: 0.75em;
  line-height: 1em;
}
.DiceboundModal .Header .SmallText[isHoverable]:hover,
.DiceboundModal .Footer .SmallText[isHoverable]:hover {
  color: hotpink;
}
.DiceboundModal .UnitsSection {
  display: flex;
  align-items: center;
  justify-content: center;
}
.DiceboundModal .UnitsSection .Or {
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
}
.DiceboundModal .UnitsSection .Unit {
  font-size: 0.75em;
  margin: 0em 0.2em;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transition-duration: 0.25s;
  transition-property: opacity, filter, transform;
}
.DiceboundModal .UnitsSection .Unit .Thumbnail {
  width: 1em;
  height: 1em;
  position: relative;
  margin-top: 0.4em;
}
.DiceboundModal .UnitsSection .Unit .Thumbnail .UnitHealthBar {
  left: 0em;
  right: 0em;
  margin: auto;
  bottom: 0em;
  height: 0.15em;
  max-width: 0.66em;
  position: absolute;
}
.DiceboundModal .UnitsSection .Unit .DraftButton {
  margin-top: 1.4em;
  width: 8em;
  height: 1.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--editor-font);
}
.DiceboundModal .UnitsSection .Unit .DraftButton span {
  font-size: 1rem;
  line-height: 1rem;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .Number {
  font-size: 0.25em;
  text-align: center;
  margin-bottom: 0.25em;
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .Description,
.DiceboundModal .UnitsSection .Unit .DraftableDice .Name {
  font-size: 0.5em;
  text-align: center;
  margin-bottom: 0.5em;
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
  height: 1em;
  line-height: 1em;
  position: relative;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .Description span,
.DiceboundModal .UnitsSection .Unit .DraftableDice .Name span {
  left: -3em;
  right: -3em;
  position: absolute;
  text-align: center;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .DiceLayout {
  background-color: transparent;
  border: none;
  font-size: 1em;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .DiceLayout .Dice .DiceFace {
  border-style: solid;
  border-width: 0.1em;
  border-radius: 0.1em;
  border-color: #111111;
}
.DiceboundModal .UnitsSection .Unit .EquippedDice {
  font-size: 0.5em;
}
.DiceboundModal .UnitsSection .Unit .EquippableDice {
  margin-top: 0.2em;
}
.DiceboundModal .UnitsSection .Unit .EquippableDice .Description {
  font-size: 0.25em;
  text-align: center;
  font-family: var(--header-font);
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
}
.DiceboundModal .UnitsSection .Unit .Status {
  left: 0em;
  right: 0em;
  bottom: -1.4em;
  position: absolute;
  line-height: 1em;
  text-align: center;
  font-size: 0.3em;
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
  opacity: 0;
  transition-duration: 0.5s;
  transition-property: opacity;
}
.DiceboundModal .UnitsSection .Unit[isLockedIn] {
  filter: grayscale(2);
  opacity: 0.75;
  transform: translateY(-0.5em);
}
.DiceboundModal .UnitsSection .Unit[isLockedIn] .Label {
  display: none;
}
.DiceboundModal .UnitsSection .Unit[isLockedIn] .Status {
  opacity: 1;
}
.DiceboundModal .DoneSection {
  padding-top: 0.5em;
  text-align: center;
}
.DiceboundModal .DoneSection button {
  font: inherit;
  font-size: 0.5em;
  padding: 0em 1em;
}
.DiceboundModal .DoneSection button:not([isEnabled]) {
  opacity: 0.5;
}
.DiceboundModal .DoneSection button:not(:last-child) {
  margin-right: 0.5em;
}
.DiceboundModal .LootablePassiveSection {
  width: 6em;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.DiceboundModal .LootablePassiveSection .LootablePassive {
  width: 100%;
  position: relative;
  background-color: rgba(0, 0, 0, 0.2);
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Unit {
  top: 0em;
  width: 1em;
  right: 0.2em;
  bottom: 0em;
  position: absolute;
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Unit .UnitSprite {
  top: 0em;
  bottom: 0em;
  margin: auto;
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Summary {
  font-size: 0.5em;
  padding: 0.618em;
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Summary .Title {
  font-size: 1em;
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Summary .Description {
  font-size: 0.5em;
}
.DiceboundModal .LootablePassiveSection .LootablePassive:not(:last-child) {
  margin-bottom: 0.2em;
}
.DiceboundModal .LootablePassiveSection .LootablePassive:hover {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
}
.FirstTimeRollModal {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: rgba(34, 34, 34, 0.5);
  background-color: none;
  animation-name: fade-in;
  animation-duration: 1s;
  animation-fill-mode: forwards;
}
.FirstTimeRollModal .Header,
.FirstTimeRollModal .Footer {
  font-size: 0.5em;
  text-align: center;
  font-family: var(--header-font);
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
  margin-top: 2em;
  margin-bottom: 2em;
}
.FirstTimeRollModal .Header .BigText,
.FirstTimeRollModal .Footer .BigText {
  font-size: 1.3em;
  line-height: 1em;
}
.FirstTimeRollModal .Header .SmallText,
.FirstTimeRollModal .Footer .SmallText {
  font-size: 0.75em;
  line-height: 1em;
}
.FirstTimeRollModal .Header .SmallText[isHoverable]:hover,
.FirstTimeRollModal .Footer .SmallText[isHoverable]:hover {
  color: hotpink;
}
.FirstTimeRollModal .UnitsSection {
  display: flex;
  align-items: center;
  justify-content: center;
}
.FirstTimeRollModal .UnitsSection .Or {
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
}
.FirstTimeRollModal .UnitsSection .Unit {
  font-size: 0.75em;
  margin: 0em 0.2em;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transition-duration: 0.25s;
  transition-property: opacity, filter, transform;
}
.FirstTimeRollModal .UnitsSection .Unit .Thumbnail {
  width: 1em;
  height: 1em;
  position: relative;
  margin-top: 0.4em;
}
.FirstTimeRollModal .UnitsSection .Unit .Thumbnail .UnitHealthBar {
  left: 0em;
  right: 0em;
  margin: auto;
  bottom: 0em;
  height: 0.15em;
  max-width: 0.66em;
  position: absolute;
}
.FirstTimeRollModal .UnitsSection .Unit .DraftButton {
  margin-top: 1.4em;
  width: 8em;
  height: 1.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--editor-font);
}
.FirstTimeRollModal .UnitsSection .Unit .DraftButton span {
  font-size: 1rem;
  line-height: 1rem;
}
.FirstTimeRollModal .UnitsSection .Unit .DraftableDice .Number {
  font-size: 0.25em;
  text-align: center;
  margin-bottom: 0.25em;
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
}
.FirstTimeRollModal .UnitsSection .Unit .DraftableDice .Description,
.FirstTimeRollModal .UnitsSection .Unit .DraftableDice .Name {
  font-size: 0.5em;
  text-align: center;
  margin-bottom: 0.5em;
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
  height: 1em;
  line-height: 1em;
  position: relative;
}
.FirstTimeRollModal .UnitsSection .Unit .DraftableDice .Description span,
.FirstTimeRollModal .UnitsSection .Unit .DraftableDice .Name span {
  left: -3em;
  right: -3em;
  position: absolute;
  text-align: center;
}
.FirstTimeRollModal .UnitsSection .Unit .DraftableDice .DiceLayout {
  background-color: transparent;
  border: none;
  font-size: 1em;
}
.FirstTimeRollModal .UnitsSection .Unit .DraftableDice .DiceLayout .Dice .DiceFace {
  border-style: solid;
  border-width: 0.1em;
  border-radius: 0.1em;
  border-color: #111111;
}
.FirstTimeRollModal .UnitsSection .Unit .EquippedDice {
  font-size: 0.5em;
}
.FirstTimeRollModal .UnitsSection .Unit .EquippableDice {
  margin-top: 0.2em;
}
.FirstTimeRollModal .UnitsSection .Unit .EquippableDice .Description {
  font-size: 0.25em;
  text-align: center;
  font-family: var(--header-font);
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
}
.FirstTimeRollModal .UnitsSection .Unit .Status {
  left: 0em;
  right: 0em;
  bottom: -1.4em;
  position: absolute;
  line-height: 1em;
  text-align: center;
  font-size: 0.3em;
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
  opacity: 0;
  transition-duration: 0.5s;
  transition-property: opacity;
}
.FirstTimeRollModal .UnitsSection .Unit[isLockedIn] {
  filter: grayscale(2);
  opacity: 0.75;
  transform: translateY(-0.5em);
}
.FirstTimeRollModal .UnitsSection .Unit[isLockedIn] .Label {
  display: none;
}
.FirstTimeRollModal .UnitsSection .Unit[isLockedIn] .Status {
  opacity: 1;
}
.FirstTimeRollModal .DoneSection {
  padding-top: 0.5em;
  text-align: center;
}
.FirstTimeRollModal .DoneSection button {
  font: inherit;
  font-size: 0.5em;
  padding: 0em 1em;
}
.FirstTimeRollModal .DoneSection button:not([isEnabled]) {
  opacity: 0.5;
}
.FirstTimeRollModal .DoneSection button:not(:last-child) {
  margin-right: 0.5em;
}
.FirstTimeRollModal .LootablePassiveSection {
  width: 6em;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.FirstTimeRollModal .LootablePassiveSection .LootablePassive {
  width: 100%;
  position: relative;
  background-color: rgba(0, 0, 0, 0.2);
}
.FirstTimeRollModal .LootablePassiveSection .LootablePassive .Unit {
  top: 0em;
  width: 1em;
  right: 0.2em;
  bottom: 0em;
  position: absolute;
}
.FirstTimeRollModal .LootablePassiveSection .LootablePassive .Unit .UnitSprite {
  top: 0em;
  bottom: 0em;
  margin: auto;
}
.FirstTimeRollModal .LootablePassiveSection .LootablePassive .Summary {
  font-size: 0.5em;
  padding: 0.618em;
}
.FirstTimeRollModal .LootablePassiveSection .LootablePassive .Summary .Title {
  font-size: 1em;
}
.FirstTimeRollModal .LootablePassiveSection .LootablePassive .Summary .Description {
  font-size: 0.5em;
}
.FirstTimeRollModal .LootablePassiveSection .LootablePassive:not(:last-child) {
  margin-bottom: 0.2em;
}
.FirstTimeRollModal .LootablePassiveSection .LootablePassive:hover {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
}
.FirstTimeRollModal .Fill {
  top: 0em;
  left: 0em;
  right: 0em;
  bottom: 0em;
  width: 100%;
  height: 100%;
  position: absolute;
  background: radial-gradient(circle 2em at center, transparent 1.9em, rgba(0, 0, 0, 0.8) 2em);
  transform: scale(10);
  animation-name: zoom-in;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: 1s;
  animation-delay: 1s;
}
.FirstTimeRollModal .Header {
  opacity: 0;
  animation-name: fade-in;
  animation-duration: 2s;
  animation-delay: 4s;
  animation-fill-mode: forwards;
}
.FirstTimeRollModal .DiceCube {
  perspective: 3em;
}
.FirstTimeRollModal .DiceCube:nth-child(1) {
  margin-top: -0.5em;
}
.FirstTimeRollModal .DiceCube:nth-child(2) {
  margin-left: 0.25em;
  margin-bottom: -0.5em;
}
.FirstTimeRollModal .DiceCube:nth-child(2) .Cube {
  animation-delay: -1.2s;
}
.FirstTimeRollModal .DiceCube:nth-child(3) {
  margin-left: 0.25em;
  margin-top: -0.5em;
}
.FirstTimeRollModal .DiceCube:nth-child(3) .Cube {
  animation-delay: -2.4s;
}
.FirstTimeRollModal .UnitsSection {
  height: 1em;
  opacity: 0;
  animation-delay: 1s;
  animation-name: fade-in;
  animation-duration: 1s;
  animation-fill-mode: forwards;
}
.FirstTimeRollModal .UnitsSection:hover .DiceCube {
  animation-name: shake-the-dice;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-duration: 0.5s;
}
@keyframes shake-the-dice {
  0% {
    transform: translateX(-0.025em) translateY(0.025em);
  }
  10% {
    transform: translateX(0) translateY(0.025em);
  }
  20% {
    transform: translateX(0.025em) translateY(0em);
  }
  30% {
    transform: translateX(0) translateY(-0.025em);
  }
  40% {
    transform: translateX(0.025em) translateY(0.025em);
  }
  50% {
    transform: translateX(-0.025em) translateY(-0.025em);
  }
  60% {
    transform: translateX(-0.025em) translateY(0.025em);
  }
  70% {
    transform: translateX(0em) translateY(-0.025em);
  }
  80% {
    transform: translateX(0.025em) translateY(0em);
  }
  90% {
    transform: translateX(-0.025em) translateY(0.025em);
  }
  100% {
    transform: translateX(0em) translateY(0em);
  }
}
